export class FetchService {
  data = [];
  status = null;

  constructor(params) {
    this.params = params;
  }

  async useFetch(fetchContent) {
    try {
      const response = await fetch(fetchContent);
      this.status = response.status;
      this.data = await response.json();

      if (this.status !== 200) {
        return Promise.reject(this.data);
      } else {
        return {
          data: this.data,
          status: this.status,
        };
      }
    } catch (err) {
      throw new Error("Backend request return error");
    }
  }

  async getPersonList() {
    return await this.useFetch(
      process.env.REACT_APP_PATH_TO_PERSON_LIST +
        new URLSearchParams(this.params)
    );
  }

  async getPersonFinance() {
    return await this.useFetch(
      process.env.REACT_APP_PATH_TO_PERSON_FINANCE +
        new URLSearchParams(this.params)
    );
  }

  async getPersonModules() {
    return await this.useFetch(
      process.env.REACT_APP_PATH_TO_PERSON_MODULES +
        new URLSearchParams(this.params)
    );
  }

  async getPersonLessons() {
    return await this.useFetch(
      process.env.REACT_APP_PATH_TO_PERSON_LESSONS +
        new URLSearchParams(this.params)
    );
  }

  async getFormingLessons() {
    return await this.useFetch(
      process.env.REACT_APP_PATH_TO_FORMING_LESSONS +
        new URLSearchParams(this.params)
    );
  }

  async getRegularLessons() {
    return await this.useFetch(
      process.env.REACT_APP_PATH_TO_REGULAR_LESSONS +
        new URLSearchParams(this.params)
    );
  }

  async getModules() {
    return await this.useFetch(process.env.REACT_APP_PATH_TO_MODULE_LIST);
  }

  async getBranches() {
    return await this.useFetch(process.env.REACT_APP_PATH_TO_BRANCH_LIST);
  }

  async getPayment() {
    return await this.useFetch(
      process.env.REACT_APP_PATH_TO_PERSON_IPAY +
        new URLSearchParams(this.params)
    );
  }
}
